import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import requestAccessRightService from '../services/requestAccessRightService';
import AccessRightFormModal from '../../accessRights/components/AccessRightFormModal';
import createVehicleService from '../../vehicles/services/createVehicleService';

let now;
const getNowOnce = () => {
  if (!now) {
    now = new Date();
    now.setHours(now.getHours(), 0, 0, 0);
  }
  return now;
};

class NewRequestModal extends PureComponent {
  handleSubmit = body => {
    const {
      dispatchRequestAccessRightPost,
      dispatchCreateVehiclePost,
      returnRoute,
      t,
    } = this.props;

    if (body.licensePlate) {
      dispatchCreateVehiclePost(body, {
        callback: data =>
          dispatchRequestAccessRightPost(
            {
              ...body,
              vehicleId: data,
              licensePlate: undefined,
              // TODO phase 2, onPremiseSelector
              onPremiseId: 'f8e3fc08-66a9-482d-becf-0169062c2dd6',
            },
            returnRoute
          ),
        toaster: {
          onErrorMessage: t('vehicleCreateErr'),
        },
        redirectRoute: returnRoute,
      });
    } else {
      dispatchRequestAccessRightPost(
        { ...body, onPremiseId: 'f8e3fc08-66a9-482d-becf-0169062c2dd6' },
        returnRoute
      );
    }
  };
  render() {
    const {
      open,
      requestAccessRightFetch,
      licensePlate,
      returnRoute,
      createVehicleFetch,
      t,
    } = this.props;
    if (!open) {
      return null;
    }
    return (
      <AccessRightFormModal
        header={`${
          licensePlate
            ? t('requestAccessRightForVehicle', { licensePlate })
            : t('requestAccessRight')
        }`}
        onSubmit={this.handleSubmit}
        submitProcessing={!!requestAccessRightFetch.pending || !!createVehicleFetch.pending}
        licensePlate={licensePlate}
        returnRoute={returnRoute}
        noStateField
        data={{
          validFrom: getNowOnce(),
        }}
      />
    );
  }
}

NewRequestModal.propTypes = {
  t: PropTypes.func.isRequired,
  dispatchRequestAccessRightPost: PropTypes.func.isRequired,
  dispatchCreateVehiclePost: PropTypes.func.isRequired,
  requestAccessRightFetch: PropTypes.object.isRequired,
  createVehicleFetch: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  licensePlate: PropTypes.string,
  returnRoute: PropTypes.string,
};

NewRequestModal.defaultProps = {
  licensePlate: undefined,
  returnRoute: '/requests',
};

export default compose(
  withTranslation(),
  requestAccessRightService,
  createVehicleService
)(NewRequestModal);
